<template>
    <div class="container">
        <div style="margin-bottom: 12px; display: flex; align-items: center;">
            <span style="font-size: 14px;">新增库存：</span>
            <el-input v-model="code" class="header-input" placeholder="请输入评级编码（回车确认录入）" style="width: 300px; margin-left: 5px;" @change="inventoryInsert"></el-input>
            <!-- <el-button type="primary" @click="inventoryInsert()" style="margin-left: 7px;">新增盘点</el-button> -->
            <el-select v-model="categoryId" placeholder="请选择钱币朝代" @change="getData()"
                style="width: 200px; margin-left: 5px;" class="header-input">
                <el-option :label="'不限朝代'" :value="'0'"></el-option>
                <el-option :label="group.categoryName" :value="group.categoryId" v-for="group in categorys"></el-option>
            </el-select>
            <el-select v-model="addressId" placeholder="请选择库存地" @change="getData()"
                style="width: 200px; margin-left: 5px;" class="header-input">
                <el-option :label="'不限库存地'" :value="'0'"></el-option>
                <el-option :label="group.addressName" :value="group.addressId" v-for="group in addresses"></el-option>
            </el-select>
            <div style="flex-grow: 1;"></div>
            <el-button type="primary" @click="inventoryExport()" style="margin-left: 7px;">导出Excel</el-button>
            <el-button type="primary" @click="inventoryClear()" style="margin-left: 7px;">清空盘点</el-button>
        </div>
        <el-tabs v-model="activeName" @tab-click="tabClick">
            <el-tab-pane :label="'正常盘点（' + count0 + '枚）'" name="tab0"></el-tab-pane>
            <el-tab-pane :label="'异常盘点（' + count1 + '枚）'" name="tab1"></el-tab-pane>
            <el-tab-pane :label="'未盘点库存（' + count2 + '枚）'" name="tab2"></el-tab-pane>
        </el-tabs>
        <!-- 表格数据 -->
        <el-table :data="records" border style="width: 100%">
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column label="钱币名称" sortable prop="productName" width="280">
                <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover">
                        <el-image style="width: 300px; height: 300px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover"></el-image>
                        <el-button type="text" slot="reference">{{ scope.row.productName }}</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="productAppraisal" label="评级编码" sortable></el-table-column>
            <el-table-column prop="productPrize" label="钱币价格" sortable></el-table-column>
            <el-table-column prop="productStatus" label="钱币状态" sortable>
                <template slot-scope="scope">
                    <span>{{ getProductStatusName(scope.row.productStatus) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="productPublic" label="公开" sortable>
                <template slot-scope="scope">{{ scope.row.productPublic == 1 ? "公开" : "不公开" }}</template>
            </el-table-column>
            <el-table-column prop="addressName" label="库存地" sortable></el-table-column>
            <el-table-column prop="customerName" label="出品人" sortable></el-table-column>
            <el-table-column prop="productDate" label="创建时间" sortable>
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.productDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="productImages" label="钱币底图">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover" :preview-src-list="getImageSrcList(scope.row.productImages)"></el-image>
                        <div v-if="scope.row.productImages && scope.row.productImages.split(',').length > 1"
                            style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 16px; height: 16px; line-height: 16px; text-align: center; color: #FFFFFF; font-size: 10px; border-radius: 50%;">
                            {{ scope.row.productImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click="inventoryDelete(scope.row.inventoryId)" type="text" size="small" v-if="active <= 1">删除</el-button>
                    <span v-if="active == 2">-</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import axios from "axios";
import { API, doGet, doPost, doDelete, doExport } from "@/api/api.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

export default {
    mixins: [imageMixin, enumMixin],
    data: function () {
        return {
            categorys: [],
            addresses: [],
            categoryId: "0",
            addressId: "0",
            code: "",
            active: 0,
            activeName: "tab0",
            count0: 0,  //正常盘点（数量）
            count1: 0,  //异常盘点（数量）
            count2: 0,  //未盘点库存（数量）
            records: [],   //数据列表
        }
    },
    methods: {
        convertToDate: function (unixTime) {
            if (unixTime) {
                const date = new Date(unixTime * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
            else {
                return "--";
            }
        },
        tabClick: function (e) {
            this.active = parseInt(e.index);
            this.getRecords();
        },
        getCount: async function () {
            this.count0 = await doGet(API.INVENTORY.GET_COUNT0, { categoryId: this.categoryId, addressId: this.addressId });
            this.count1 = await doGet(API.INVENTORY.GET_COUNT1, { categoryId: this.categoryId, addressId: this.addressId });
            this.count2 = await doGet(API.INVENTORY.GET_COUNT2, { categoryId: this.categoryId, addressId: this.addressId });
        },
        getRecords: async function () {
            if (this.active == 0) {
                this.records = await doGet(API.INVENTORY.GET_RECORDS0, { categoryId: this.categoryId, addressId: this.addressId });
            }
            else if (this.active == 1) {
                this.records = await doGet(API.INVENTORY.GET_RECORDS1, { categoryId: this.categoryId, addressId: this.addressId });
            }
            else if (this.active == 2) {
                this.records = await doGet(API.INVENTORY.GET_RECORDS2, { categoryId: this.categoryId, addressId: this.addressId });
            }
        },
        inventoryInsert: async function () {
            if (this.code.indexOf("、") >= 0) {
                this.code = this.code.substring(this.code.lastIndexOf("、") + 1);
            }
            if (this.code) {
                let temp = await doPost(API.INVENTORY.INSERT, {
                    code: this.code
                });
                if (temp.errorCode > 0) {
                    this.$message.error(temp.errorMessage);
                    this.code = "";
                }
                else {
                    this.$message.success("操作成功");
                    this.code = "";
                    this.getData();
                }
            }
            else {
                this.$message.error("请输入评级编码！");
            }
        },
        inventoryDelete: async function (id) {
            if (confirm("您确认要删除当前数据吗？")) {
                let temp = await doDelete(API.INVENTORY.DELETE, id);
                if (temp.errorCode > 0) {
                    this.$message.error(temp.errorMessage);
                }
                else {
                    this.$message.success("操作成功");
                    this.getData();
                }
            }
        },
        inventoryExport: function() {
            axios.get(process.env.VUE_APP_BASE_API + API.INVENTORY.EXPORT + "?categoryId=" + this.categoryId, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = (new Date()).getTime() + '.xlsx';
                    link.click();
                });
        },
        inventoryClear: async function () {
            if (confirm("您确认要删除所有的盘点数据吗？")) {
                let temp = await doGet(API.INVENTORY.CLEAR);
                if (temp.errorCode > 0) {
                    this.$message.error(temp.errorMessage);
                }
                else {
                    this.$message.success("操作成功");
                    this.getData();
                }
            }
        },
        getData: function () { 
            this.getCount();
            this.getRecords();
        }
    },
    created: async function () {
        this.categorys = await doGet(API.ALL.CATEGORY);
        this.addresses = await doGet(API.ALL.ADDRESS);
        this.getData();
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>